var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.progress != 100),expression:"progress != 100"}],staticClass:"preload-content"},[_c('p',[_vm._v("资源加载中")]),_c('p',[_vm._v("进度 "+_vm._s(_vm.progress)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }